if (!customElements.get("search-type-switchs")) {
    class SearchTypeSwitchs extends HTMLElement {
        constructor() {
            super();
            this.switches = this.querySelectorAll(".search-type-switchs__item");
            this.counter = this.querySelectorAll(".search-type-switchs__item_count");
            this.isFetching = false; // 用于防止在fetching期间触发
            this.attachEventListeners();
            this.checkUrl(); // 在页面初始化时执行checkUrl()
            this.updateCountMobile();
        }

        attachEventListeners() {
            this.switches.forEach((switchItem) => {
                // 直接绑定handleSwitchClick方法，不使用防抖
                switchItem.addEventListener("click", this.handleSwitchClick.bind(this));
            });
        }

        handleSwitchClick(event) {
            if (this.isFetching) return; // 在fetching期间不执行

            // 使用event.target而不是event.currentTarget来获取被点击的元素
            const clickedSwitch = event.target;
            const clickedSwitchParent = clickedSwitch.closest(".search-type-switchs__item");
            // console.log(clickedSwitch); // 输出调试信息

            // 如果点击的元素已有active类，则返回
            if (clickedSwitchParent.classList.contains("active")) return;

            // 获取data-type值
            const searchType = clickedSwitchParent.dataset.type;
            const url = new URL(window.location);

            // 如果data-type不是product，移除URL中所有&后面的属性
            if (searchType !== "product") {
                url.search = url.search.split("&")[0];
            }

            // 将data-type值添加到URL参数中
            url.searchParams.set("type", searchType);
            window.history.pushState({}, "", url);

            // 更新active类
            this.updateActiveClass(clickedSwitchParent);

            // 在获取内容前，执行fetching()方法
            this.fetching();

            // 使用Promise.all等待两个fetch完成后再执行后续逻辑
            Promise.all([
                this.fetchAndUpdateContent(url, ".search-type-switchs__item_count", this.updateCounter.bind(this)),
                this.fetchAndUpdateContent(url, ".main-collection-v2", this.updateMainCollection.bind(this)),
            ]).then(() => {
                this.updateCountMobile();
                // 两个fetch都完成后移除loading类
                this.finishLoading([...this.counter, document.querySelector(".main-collection-v2"), document.querySelector('.search-count-mobile'), ...this.switches]);
            });
        }

        updateActiveClass(clickedSwitch) {
            // 移除其他元素的active类，给当前点击的元素添加active类
            this.switches.forEach((switchItem) => switchItem.classList.remove("active"));
            clickedSwitch.classList.add("active");
        }

        fetching() {
            this.isFetching = true; // 开始fetching，设置状态为true
            const elementsToLoad = [...this.counter, document.querySelector(".main-collection-v2"), document.querySelector('.search-count-mobile'), ...this.switches];
            elementsToLoad.forEach((element) => {
                if (element) element.classList.add("loading");
            });
        }

        finishLoading(elements) {
            elements.forEach((element) => {
                if (element) {
                    // 注释掉控制台日志
                    // console.log("移除loading", element);
                    element.classList.remove("loading");
                }
            });
            this.isFetching = false; // fetching完成，设置状态为false
        }

        checkCounter() {
            this.counter.forEach((counterItem) => {
                const searchCountElement = counterItem.querySelector(".search-count");
                if (searchCountElement && searchCountElement.textContent.trim() === "1") {
                    counterItem.textContent = counterItem.textContent.replace("results", "result");
                }
            });
        }

        fetchAndUpdateContent(url, selector, updateCallback) {
            return fetch(url.toString(), {
                method: "GET",
                headers: {
                    "Content-Type": "text/html",
                },
            })
                .then((response) => {
                    if (!response.ok) throw new Error("Network response failed");
                    return response.text();
                })
                .then((html) => this.parseAndUpdateContent(html, selector, updateCallback))
                .catch((error) => {
                    console.error("Error fetching content:", error);
                })
                .finally(() => {
                    if (selector === ".search-type-switchs__item_count") {
                        this.checkCounter();
                    } else if (selector === ".main-collection-v2") {
                        this.checkUrl(); // 再次检查URL，更新状态
                    }
                });
        }

        parseAndUpdateContent(html, selector, updateCallback) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // 更新 <title> 元素的内容
            const newTitle = doc.querySelector("title");
            if (newTitle) {
                document.title = newTitle.textContent;
            } else {
                console.warn("No <title> element found");
            }

            const newContent = doc.querySelector(selector);
            if (newContent) {
                updateCallback(newContent);
            } else {
                console.warn(`No element found for selector: ${selector}`);
            }
        }

        updateCounter(newContent) {
            // 更新页面的 .search-type-switchs__item_count 内容
            this.counter.forEach((itemCountElement) => {
                itemCountElement.innerHTML = newContent.innerHTML;
            });
        }

        updateMainCollection(newContent) {
            // 更新页面的 .main-collection-v2 内容
            const mainCollection = document.querySelector(".main-collection-v2");
            if (mainCollection) {
                mainCollection.innerHTML = newContent.innerHTML;
            }
        }

        checkUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            const type = urlParams.get("type");

            // 重新选择最新的 .search-main-container
            const mainContainer = document.querySelectorAll(".search-main-container");

            if (type && ["product", "page", "article"].includes(type)) {
                this.updateSwitchesAndContainers(type, mainContainer);
            } else {
                this.defaultToProductType(mainContainer, urlParams);
            }
        }

        updateSwitchesAndContainers(type, mainContainer) {
            // 匹配this.switches，不匹配的去掉active类
            this.switches.forEach((switchItem) => {
                const itemType = switchItem.dataset.type;
                switchItem.classList.toggle("active", itemType === type);
            });

            mainContainer.forEach((mainItem) => {
                const itemType = mainItem.dataset.type;
                mainItem.classList.toggle("active", itemType === type);
            });
        }

        defaultToProductType(mainContainer, urlParams) {
            if (!urlParams.has("type")) {
                this.fetching();
                const url = new URL(window.location);
                url.searchParams.set("type", "product");
                window.history.pushState({}, "", url.toString());

                this.fetchAndUpdateContent(url, ".main-collection-v2", this.updateMainCollection.bind(this)).then(() => {
                    this.finishLoading([document.querySelector(".main-collection-v2"), ...this.switches]);
                });

                // 如果没有有效的type参数，移除所有的active类
                this.switches.forEach((switchItem) => switchItem.classList.remove("active"));
                mainContainer.forEach((mainItem) => mainItem.classList.remove("active"));
                // 默认选中第一个
                this.switches[0].classList.add("active");
                mainContainer[0].classList.add("active");
            }
        }

        updateCountMobile() {
            if (window.matchMedia("(max-width: 768px)").matches) {
                const searchCountMobile = document.querySelector(".search-count-mobile");
                const urlParams = new URLSearchParams(window.location.search);
                const type = urlParams.get("type");

                if (type && ["product"].includes(type) || !urlParams.has("type")) {
                    searchCountMobile.classList.add('hide');
                } else {
                    searchCountMobile.classList.remove('hide');
                }

                const activeItemCount = this.querySelector(".search-type-switchs__item.active .search-type-switchs__item_count");
                if (searchCountMobile && activeItemCount) {
                    searchCountMobile.innerHTML = activeItemCount.innerHTML; // 更新移动端计数内容
                }
            }
        }
    }

    customElements.define("search-type-switchs", SearchTypeSwitchs);
}
